// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"f9651c9c","475":"f193d2c2"}[chunkId] + ".chunk.js";
};